import { render, staticRenderFns } from "./AdsEditorModal.vue?vue&type=template&id=03983d83&scoped=true"
import script from "./AdsEditorModal.vue?vue&type=script&lang=js"
export * from "./AdsEditorModal.vue?vue&type=script&lang=js"
import style0 from "./AdsEditorModal.vue?vue&type=style&index=0&id=03983d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03983d83",
  null
  
)

export default component.exports